import { makeAutoObservable } from "mobx";
import {getAllPosts, dropPost, getLastPost, storePost, editPost} from "../http/postsAPI";
import {EXAMPLE_CATEGORIES} from "../utils/const";

export default class PostsStore {
    constructor() {
        this._posts = [];
        this._categoryPosts = [];
        this._pagination = {};
        this._categoryPagination = {};
        this._availableCategories = {};
        this._error = false;
        this._errorMessage = '';
        this._editingPostId = '';
        this._editingPost = null;
        this._lastPost = null;
        this._currentHeader = '';
        this._currentText = '';
        this._currentCategory = EXAMPLE_CATEGORIES[0];
        makeAutoObservable(this);
    }

    setCurrentHeader(header) {
        this._currentHeader = header;
    }
    setCurrentText(text) {
        this._currentText = text;
    }
    setCurrentCategory(category) {
        this._currentCategory = category;
    }
    setPosts(posts) {
        this._posts = posts;
    }
    setCategoryPosts(posts) {
        this._categoryPosts = posts;
    }
    setError(error) {
        this._error = error;
    }
    setErrorMessage(errorMessage) {
        this._errorMessage = errorMessage;
    }
    setEditingPostId(id) {
        this._editingPostId = id;
    }
    setEditingPost(post) {
        this._editingPost = post;
    }
    setLastPost(post) {
        this._lastPost = post ?? null;
    }
    setPagination(pagination) {
        this._pagination = pagination;
    }
    setCategoryPagination(pagination) {
        this._categoryPagination = pagination;
    }
    setAvailableCategories(categories) {
        this._availableCategories = categories;
    }

    get posts() {
        return this._posts;
    }
    get categoryPosts() {
        return this._categoryPosts;
    }
    get error() {
        return this._error;
    }
    get errorMessage() {
        return this._errorMessage;
    }
    get editingPostId() {
        return this._editingPostId;
    }
    get editingPost() {
        return this._editingPost;
    }
    get lastPost() {
        return this._lastPost
    }
    get pagination() {
        return this._pagination;
    }
    get categoryPagination() {
        return this._categoryPagination;
    }
    isCategoryAvailable(category) {
        return Boolean(this._availableCategories[category]);
    }
    get currentHeader() {
        return this._currentHeader;
    }
    get currentText() {
        return this._currentText;
    }
    get currentCategory() {
        return this._currentCategory;
    }

    async loadPosts(number, category = '') {
        try {
            const posts = await getAllPosts(number, category);
            this.setPosts(posts.posts);
            this.setPagination(posts.pagination);
            this.setError(false);
        } catch (e) {
            this.setError(true);
            this.setErrorMessage('Ошибка загрузки');
        }
    }
    async loadPostsByCategory(category, number = 1) {
        try {
            const posts = await getAllPosts(number, category, 100);
            this.setCategoryPosts(posts.posts);
            this.setCategoryPagination(posts.pagination);
            this.setError(false);
            this.setErrorMessage('');
        } catch (e) {
            this.setCategoryPosts([]);
            this.setCategoryPagination({});
            this.setErrorMessage('Ошибка загрузки примеров работ');
        }
    }
    async loadAvailableCategories() {
        const results = await Promise.all(EXAMPLE_CATEGORIES.map(async (category) => {
            try {
                const posts = await getAllPosts(1, category, 1);
                return [category, posts.posts.length > 0];
            } catch (e) {
                return [category, false];
            }
        }));

        this.setAvailableCategories(Object.fromEntries(results));
    }

    async deletePost() {
        try {
            await dropPost(this.editingPostId);
            this.setError(false);
            await this.loadPosts(this.pagination.current || 1);
            return true;
        } catch (e) {
            this.setError(false);
            this.setErrorMessage(e?.response?.data?.message || 'Не удалось удалить пример работ');
            return false;
        }
    }
    async createPost() {
        try {
            await storePost(this.currentHeader, this.currentHeader, this.currentCategory);
            this.setError(false);
            await this.loadPosts();
            this.setCurrentText('');
            this.setCurrentHeader('');
            this.setCurrentCategory(EXAMPLE_CATEGORIES[0]);
            return true;
        } catch (e) {
            this.setError(false);
            this.setErrorMessage(e?.response?.data?.message || 'Не удалось создать пример работ');
            return false;
        }
    }
    async updatePost() {
        try {
            await editPost(
                this.editingPostId,
                this.currentHeader,
                this.currentHeader,
                this.currentCategory,
                this.editingPost,
            );
            this.setError(false);
            await this.loadPosts(this.pagination.current || 1);
            this.setCurrentHeader('');
            this.setCurrentCategory(EXAMPLE_CATEGORIES[0]);
            return true;
        } catch (e) {
            this.setError(false);
            this.setErrorMessage(e?.response?.data?.message || 'Не удалось изменить пример работ');
            return false;
        }
    }
    async loadLastPost() {
        try {
            const post = await getLastPost();
            this.setLastPost(post);
            this.setError(false);
        } catch (e) {
            this.setError(true);
            this.setErrorMessage('Ошибка загрузки');
        }
    }
}
